module.exports = __webpack_public_path__ + "img/ye.d4cc9017.svg";